__turbopack_context__.v({
  "container": "styles-module__TToDKG__container",
  "disclaimerText": "styles-module__TToDKG__disclaimerText",
  "headingWrapper": "styles-module__TToDKG__headingWrapper",
  "imageWrapper": "styles-module__TToDKG__imageWrapper",
  "list": "styles-module__TToDKG__list",
  "listItem": "styles-module__TToDKG__listItem",
  "protectionLink": "styles-module__TToDKG__protectionLink",
  "section": "styles-module__TToDKG__section",
  "subheading": "styles-module__TToDKG__subheading",
  "textWrapper": "styles-module__TToDKG__textWrapper",
});
